module.exports = "/static/assets/c3786aedc4f52d309d7d570dbaf0f6a5.png";